import React, { useState, useEffect } from 'react';
import {
    Box,
    Typography,
    Button,
    Card,
    CardMedia,
    CardContent,
    Chip,
    Divider,
    RadioGroup,
    FormControlLabel,
    Radio,
    IconButton,
    TextField,
    Paper,
    Stack,
    CircularProgress,
    Snackbar,
    Alert
} from '@mui/material';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { addToCart, checkVariantExist } from '../axios/api';
import RemoveIcon from '@mui/icons-material/Remove';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import AddIcon from '@mui/icons-material/Add';
import ProductsSlider from './productSlider';

const ProductDisplayPanel = ({ product }) => {
    const [selectedAttributes, setSelectedAttributes] = useState({});
    const [isVariantAvailable, setIsVariantAvailable] = useState(false);
    const [variantId, setVairantId] = useState("");
    const [price, setPrice] = useState(0);
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [discountPrice, setDiscountPrice] = useState(0);
    const [quantity, setQuantity] = useState(1);
    const [loading, setLoading] = useState(false)
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    // Add preset quantity values
    const presetQuantities = [5, 10];

    console.log(price, variantId);

    const handleAttributeSelect = (name, value) => {
        const newAttributes = { ...selectedAttributes, [name]: value };
        setSelectedAttributes(newAttributes);

        checkVariantAvailability(newAttributes);
    };

    const createVariantString = (attributes) => {
        let variantString = "";

        Object.keys(attributes).forEach((key, index) => {
            variantString += `${key}-${attributes[key]}`;

            if (index !== Object.keys(attributes).length - 1) {
                variantString += ",";
            }
        });

        return variantString;
    };

    const checkVariantAvailability = async (selectedAttributes) => {
        const variantString = createVariantString(selectedAttributes);
        const response = await checkVariantExist({ productId: product._id, variant: variantString });
        if (response.data.exists) {
            const variantIndex = product?.variants?.findIndex((val) => val._id === response?.data?.id);
            setPrice(product?.variants[variantIndex]?.price);
            setDiscountPrice(product?.variants[variantIndex]?.discountPrice);
            setIsVariantAvailable(response.data.exists);
            setVairantId(response.data.id);
            setTotalQuantity(product?.variants[variantIndex]?.quantity);
        } else {
            setIsVariantAvailable(false);
            setVairantId("");
            setTotalQuantity(0);
        }
    };

    const handleQuantityChange = (type) => {
        setQuantity(prev => {
            if (type === 'increase' && prev < totalQuantity) return prev + 1;
            if (type === 'decrease' && prev > 1) return prev - 1;
            return prev;
        });
    };

    const handleSetQuantity = (value) => {
        if (value >= 1 && value <= totalQuantity) {
            setQuantity(value);
        }
    };

    const handleAddToCart = async (id) => {
        setLoading(true)
        try {
            const response = await addToCart({ productId: id, quantity, variantId });
            if (response.status === 200) {
                setLoading(false)
                setSnackbarOpen(true)
            }
        } catch (error) {
            setLoading(false)
            console.log(error);
        }
    };

    const calculateTotal = () => {
        return ((discountPrice || price) * quantity).toFixed(2);
    };

    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };

    useEffect(() => {
        if (product?.type === "simple") {
            setPrice(Number(product?.price));
            setTotalQuantity(Number(product?.quantity) ?? 0);
            setDiscountPrice(Number(product?.discountPrice) ?? 0);
            setIsVariantAvailable(true);
        }
        if (product && product?.attributes && product?.attributes?.length > 0 && product?.variants && product?.variants?.length > 0 && product?.type === "variant") {
            const initialAttributes = {};

            product?.variants[0]?.variant?.forEach((variant) => {
                initialAttributes[variant.name] = variant.value;
            });
            setSelectedAttributes(initialAttributes);
            setVairantId(product?.variants[0]?._id);
            setPrice(product?.variants[0]?.price);
            setDiscountPrice(product?.variants[0]?.discountPrice);
            setTotalQuantity(product?.variants[0]?.quantity);
            setIsVariantAvailable(true);
        }
    }, [product]);
// Navigation button styles
// const navButtonStyle: React.CSSProperties = {
//     position: 'absolute',
//     top: '50%',
//     transform: 'translateY(-50%)',
//     // background: 'rgba(0,0,0,0.5)',
//     boxShadow: '0 0 10px #00000057',
//     background: '#00000033',
//     color: 'white',
//     border: 'none',
//     padding: '5px',
//     zIndex: 10,
//     cursor: 'pointer',
//     borderRadius: '50%',
//   };
    return (
        <Card className='product-card-wapper' elevation={3} sx={{ m: 2 }} >
            <CardMedia
                component="img"
                height="85"
                width="70"
                image={product.productImages[0] || "https://via.placeholder.com/300x200?text=Product+Image"}
                alt={product.title}
                sx={{ objectFit: 'cover' }}
            />
            <CardContent className='px-2 py-2'>
                <Typography variant="h6" fontWeight="bold" sx={{ color: '#1976d2' }} className='product-sub-title'>
                    {product.title}
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                    <Typography variant="h5"  fontWeight="bold" className='product-price'>
                        ${discountPrice || price}
                    </Typography>
                    {discountPrice > 0 && (
                        <Typography variant="body2" color="text.secondary" sx={{ textDecoration: 'line-through' }}>
                            ${price}
                        </Typography>
                    )}
                </Box>

             



        
            </CardContent>
            <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={handleCloseSnackbar}>
                <Alert onClose={handleCloseSnackbar} severity="success" sx={{ width: '100%' }}>
                    Product added to cart!
                </Alert>
            </Snackbar>
        </Card>
    );
};



const ProductGrid = ({ products }) => {
    return (
        <Box className="display-products-wrapper px-2 py-2" sx={{  }}>
            {products?.length > 0 && <ProductsSlider data={products} />}
        </Box>
    );
};

export default ProductGrid;